import { ChallengeDefActivityTypeEntity, FitnessActivityEntity, FitnessActivityTypeEntity } from '../../../meta-data/app-meta-data.service';

export function activityTypeAvailable(type: FitnessActivityTypeEntity, overrides: ChallengeDefActivityTypeEntity[]): boolean {
    const override = overrides.find(row => row.FitnessActivityTypeId === type.FitnessActivityTypeId);
    return (override?.IsIncluded ?? type.IsStandard) === true;
}

export interface ActivityTypeUsage extends FitnessActivityEntity { Total?: number; }
export function rankActivityTypes(types: FitnessActivityTypeEntity[], usage: ActivityTypeUsage[]): FitnessActivityTypeEntity[] {
    const defaults = ['Running', 'Biking', 'Swimming'];
    const frequency = new Map(usage.map(row => [row.FitnessActivityTypeId, Number(row.Total || 0)]));
    const fallback = (type: FitnessActivityTypeEntity) => {
        const index = defaults.indexOf(type.ActivityTypeName); return index < 0 ? defaults.length : index;
    };
    return types.slice().sort((a, b) => (frequency.get(b.FitnessActivityTypeId) || 0) - (frequency.get(a.FitnessActivityTypeId) || 0)
        || fallback(a) - fallback(b) || (a.ActivityTypeName || '').localeCompare(b.ActivityTypeName || '') || a.FitnessActivityTypeId - b.FitnessActivityTypeId);
}
export function activityTitle(type: FitnessActivityTypeEntity, seconds: number, distance: number, unit: string, count?: number): string {
    if (!type) { return ''; }
    const verb = type.ActivityDisplayPresent || type.ActivityTypeName.toLowerCase();
    if (distance > 0) { return `${Number(distance.toFixed(2))} ${unit === 'mi' ? 'mile' : unit === 'km' ? 'kilometer' : unit} ${verb}`; }
    if (seconds > 0) {
        const hours = Math.floor(seconds / 3600), minutes = Math.floor(seconds % 3600 / 60), remainder = seconds % 60;
        const duration = [hours ? `${hours} hour` : '', minutes ? `${minutes} minute` : '', remainder ? `${remainder} second` : ''].filter(Boolean).join(' ');
        return `${duration} ${verb}`;
    }
    return count > 0 ? `${count} ${type.CountDisplay || verb}` : type.ActivityTypeName;
}
